var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReemNine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 85,
    viewBox: "0 0 101 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.705 67L16.395 63.598H15.653V67H13.273V57.2H17.641C19.713 57.2 21.001 58.432 21.001 60.476C21.001 62.044 20.245 62.982 19.041 63.374L21.617 67H18.705ZM18.593 60.504C18.593 59.818 18.173 59.468 17.375 59.468H15.653V61.512H17.375C18.201 61.512 18.593 61.176 18.593 60.504ZM29.7007 59.468H25.3327V60.924H29.3087V63.192H25.3327V64.732H29.7007V67H22.9527V57.2H29.7007V59.468ZM37.9175 59.468H33.5495V60.924H37.5255V63.192H33.5495V64.732H37.9175V67H31.1695V57.2H37.9175V59.468ZM46.4983 57.2H49.2003V67H46.8203V60.532L44.3703 64.27H44.1463L41.6963 60.532V67H39.3163V57.2H42.0183L44.2583 60.56L46.4983 57.2ZM61.473 57.2H63.853V67H61.151L57.469 60.826L57.665 62.898V67H55.285V57.2H57.987L61.655 63.374L61.473 61.302V57.2ZM65.7456 67V57.2H68.1256V67H65.7456ZM76.1976 57.2H78.5776V67H75.8756L72.1936 60.826L72.3896 62.898V67H70.0096V57.2H72.7116L76.3796 63.374L76.1976 61.302V57.2ZM87.2182 59.468H82.8502V60.924H86.8262V63.192H82.8502V64.732H87.2182V67H80.4702V57.2H87.2182V59.468Z",
    fill: "#3C373A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_109_1159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6072 27.1883C66.5028 25.1515 67 22.8992 67 20.5306C67 11.401 59.6127 4 50.5 4C41.3873 4 34 11.401 34 20.5306C34 22.4631 34.331 24.3181 34.9392 26.0418L34.917 26.041C34.9801 26.1946 35.0444 26.3487 35.1098 26.5032C35.2961 26.9845 35.5041 27.4549 35.7328 27.9132C39.1043 35.2465 44.8023 43.2916 50.5003 49.0002C56.6878 42.8012 63.242 32.8829 65.6253 27.189L65.6072 27.1883Z",
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 19.3216,
    rx: 9.42857,
    ry: 9.42857,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_109_1159",
    x: 31,
    y: 4,
    width: 39,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_1159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_1159",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReemNine);
export default __webpack_public_path__ + "static/media/Reem Nine.25ffc3f50fecf66040d89f3f254c5f8e.svg";
export { ForwardRef as ReactComponent };